// Pho Ha Long Menu
// Cash prices are the standard price; card prices include a 4% surcharge
const pho = [
  {
    title: "Rare Steak",
    price: "$14.99",
    cardPrice: "$15.59",
    tags: "#1",
  },
  {
    title: "Rare Steak Meatball",
    price: "$14.99",
    cardPrice: "$15.59",
    tags: "#2",
  },
  {
    title: "Rare Steak, Brisket",
    price: "$14.99",
    cardPrice: "$15.59",
    tags: "#3",
  },
  {
    title: "Brisket",
    price: "$14.99",
    cardPrice: "$15.59",
    tags: "#4",
  },
  {
    title: "Meatball",
    price: "$14.99",
    cardPrice: "$15.59",
    tags: "#5",
  },
  {
    title: "Rare Steak, Flank",
    price: "$14.99",
    cardPrice: "$15.59",
    tags: "#6",
  },
  {
    title: "Rare Steak, Fat Brisket",
    price: "$14.99",
    cardPrice: "$15.59",
    tags: "#7",
  },
  {
    title: "Brisket, Flank",
    price: "$14.99",
    cardPrice: "$15.59",
    tags: "#8",
  },
  {
    title: "Steak, Flank, Fat Brisket",
    price: "$14.99",
    cardPrice: "$15.59",
    tags: "#9",
  },
  {
    title: "Steak, Flank, Tripe",
    price: "$14.99",
    cardPrice: "$15.59",
    tags: "#10",
  },
  {
    title: "Steak, Flank, Tendon",
    price: "$14.99",
    cardPrice: "$15.59",
    tags: "#11",
  },
  {
    title: "Steak, Fat Brisket, Tendon",
    price: "$14.99",
    cardPrice: "$15.59",
    tags: "#12",
  },
  {
    title: "Steak, Fat Brisket, Tripe",
    price: "$14.99",
    cardPrice: "$15.59",
    tags: "#13",
  },
  {
    title: "Brisket, Fat Brisket, Tripe",
    price: "$14.99",
    cardPrice: "$15.59",
    tags: "#14",
  },
  {
    title: "Beef Combination",
    price: "$16.99",
    cardPrice: "$17.67",
    tags: "#15",
  },
  {
    title: "Chicken Breast",
    price: "$14.99",
    cardPrice: "$15.59",
    tags: "#16",
  },
  {
    title: "Slice BBQ Pork",
    price: "$14.99",
    cardPrice: "$15.59",
    tags: "#17",
  },
  {
    title: "Shrimp",
    price: "$14.99",
    cardPrice: "$15.59",
    tags: "#18",
  },
  {
    title: "Vegetables, Tofu",
    price: "$14.99",
    cardPrice: "$15.59",
    tags: "#19",
  },
  {
    title: "Vegetable (Broccoli, Carrot, Cabbage)",
    price: "$14.99",
    cardPrice: "$15.59",
    tags: "#20",
  },
  {
    title: "No Meat",
    price: "$13.99",
    cardPrice: "$14.55",
    tags: "#21",
  },
  {
    title: "Seafood (Shrimp, Squid, Fishball, Crab)",
    price: "$15.99",
    cardPrice: "$16.63",
    tags: "#22",
  },
  {
    title: "Bun Bo Hue",
    price: "$16.99",
    cardPrice: "$17.67",
    tags: "#23",
  },
  {
    title: "Beef",
    price: "$7.00",
    cardPrice: "$7.28",
    tags: "Addition",
  },
  {
    title: "Meat",
    price: "$5.00",
    cardPrice: "$5.20",
    tags: "Addition",
  },
  {
    title: "Noodle",
    price: "$4.00",
    cardPrice: "$4.16",
    tags: "Addition",
  },
  {
    title: "Vegetable",
    price: "$3.00",
    cardPrice: "$3.12",
    tags: "Addition",
  },
  {
    title: "White Rice",
    price: "$2.00",
    cardPrice: "$2.08",
    tags: "Addition",
  },
  {
    title: "Egg Noodle",
    price: "$2.00",
    cardPrice: "$2.08",
    tags: "Addition",
  },
];

const appetizer = [
  {
    title: "Fresh Pork & Shrimp (With Peanut Sauce)",
    price: "$5.00",
    cardPrice: "$5.20",
    tags: "#24",
  },
  {
    title: "Spring Rolls Grill Pork (With Peanut Sauce)",
    price: "$5.00",
    cardPrice: "$5.20",
    tags: "#25",
  },
  {
    title: "Spring Rolls Grill Chicken (With Peanut Sauce)",
    price: "$5.00",
    cardPrice: "$5.20",
    tags: "#26",
  },
  {
    title: "Spring Rolls Grill Tofu (With Peanut Sauce)",
    price: "$5.00",
    cardPrice: "$5.20",
    tags: "#27",
  },
  {
    title: "Spring Rolls Grill Shrimp (With Peanut Sauce)",
    price: "$5.00",
    cardPrice: "$5.20",
    tags: "#28",
  },
  {
    title: "Fried Egg Rolls (Egg Wrap And Fish Sauce)",
    price: "$5.00",
    cardPrice: "$5.20",
    tags: "#29",
  },
  {
    title: "Fried Spring Rolls (Rice Wrap And Fish Sauce)",
    price: "$5.00",
    cardPrice: "$5.20",
    tags: "#30",
  },
];

const vermicelli = [
  {
    title: "Grilled Chicken",
    price: "$14.99",
    cardPrice: "$15.59",
    tags: "#31",
  },
  {
    title: "Grilled Pork",
    price: "$14.99",
    cardPrice: "$15.59",
    tags: "#32",
  },
  {
    title: "Eggrolls",
    price: "$14.99",
    cardPrice: "$15.59",
    tags: "#33",
  },
  {
    title: "Grilled Shrimp",
    price: "$14.99",
    cardPrice: "$15.59",
    tags: "#34",
  },
  {
    title: "Grilled Tofu",
    price: "$14.99",
    cardPrice: "$15.59",
    tags: "#35",
  },
  {
    title: "Combination",
    price: "$16.99",
    cardPrice: "$17.67",
    tags: "#36",
  },
  {
    title: "Beef Broccoli",
    price: "$16.99",
    cardPrice: "$17.67",
    tags: "#37",
  },
  {
    title: "Beef Lemon Grass",
    price: "$16.99",
    cardPrice: "$17.67",
    tags: "#38",
  },
  {
    title: "Chicken Broccoli",
    price: "$15.99",
    cardPrice: "$16.63",
    tags: "#39",
  },
  {
    title: "Chicken Lemon Grass",
    price: "$15.99",
    cardPrice: "$16.63",
    tags: "#40",
  },
  {
    title: "White Rice / Pork Chop, Egg",
    price: "$15.99",
    cardPrice: "$16.63",
    tags: "#88",
  },
];

const lomein = [
  {
    title: "Chicken",
    price: "$15.99",
    cardPrice: "$16.63",
    tags: "#41",
  },
  {
    title: "Pork",
    price: "$15.99",
    cardPrice: "$16.63",
    tags: "#42",
  },
  {
    title: "Vegetable",
    price: "$15.99",
    cardPrice: "$16.63",
    tags: "#43",
  },
  {
    title: "Shrimp",
    price: "$16.99",
    cardPrice: "$17.67",
    tags: "#44",
  },
  {
    title: "Beef",
    price: "$16.99",
    cardPrice: "$17.67",
    tags: "#45",
  },
  {
    title: "Combination",
    price: "$17.99",
    cardPrice: "$18.71",
    tags: "#46",
  },
];

const rice_and_noodle = [
  {
    title: "Chicken",
    price: "$15.99",
    cardPrice: "$16.63",
    tags: "#47",
  },
  {
    title: "Pork",
    price: "$15.99",
    cardPrice: "$16.63",
    tags: "#48",
  },
  {
    title: "Vegetable",
    price: "$15.99",
    cardPrice: "$16.63",
    tags: "#49",
  },
  {
    title: "Shrimp",
    price: "$16.99",
    cardPrice: "$17.67",
    tags: "#50",
  },
  {
    title: "Beef",
    price: "$16.99",
    cardPrice: "$17.67",
    tags: "#51",
  },
  {
    title: "Combination",
    price: "$17.99",
    cardPrice: "$18.71",
    tags: "#52",
  },
];

const kids = [
  {
    title: "Vermicelli or White Rice Chicken",
    price: "$8.50",
    cardPrice: "$8.84",
    tags: "#53",
  },
  {
    title: "Vermicelli or White Rice Pork",
    price: "$8.50",
    cardPrice: "$8.84",
    tags: "#54",
  },
  {
    title: "Vermicelli or White Rice Shrimp",
    price: "$8.50",
    cardPrice: "$8.84",
    tags: "#55",
  },
  {
    title: "Pho Rare Steak",
    price: "$8.00",
    cardPrice: "$8.32",
    tags: "#56",
  },
  {
    title: "Pho Brisket",
    price: "$8.00",
    cardPrice: "$8.32",
    tags: "#57",
  },
  {
    title: "Pho Meatball",
    price: "$8.00",
    cardPrice: "$8.32",
    tags: "#58",
  },
  {
    title: "Pho Chicken",
    price: "$8.00",
    cardPrice: "$8.32",
    tags: "#59",
  },
];

const beverages = [
  {
    title: "Vietnamese Coffee",
    price: "$7.00",
    cardPrice: "$7.28",
    tags: "#60",
  },
  {
    title: "Lemonade",
    price: "$3.50",
    cardPrice: "$3.64",
    tags: "#61",
  },
  {
    title: "Jasmine Hot Tea",
    price: "$4.00",
    cardPrice: "$4.16",
    tags: "#62",
  },
  {
    title: "Ice Tea",
    price: "$2.00",
    cardPrice: "$2.08",
    tags: "#63",
  },
  {
    title: "Coke",
    price: "$2.00",
    cardPrice: "$2.08",
    tags: "#65",
  },
  {
    title: "Dr. Pepper",
    price: "$2.00",
    cardPrice: "$2.08",
    tags: "#66",
  },
  {
    title: "Sprite",
    price: "$2.00",
    cardPrice: "$2.08",
    tags: "#66",
  },
  {
    title: "Big Red",
    price: "$2.00",
    cardPrice: "$2.08",
    tags: "#67",
  },
  {
    title: "Bottle Water",
    price: "$2.00",
    cardPrice: "$2.08",
    tags: "#68",
  },
];

const boba = [
  {
    title: "Coconut",
    price: "$6.50",
    cardPrice: "$6.76",
    tags: "#69",
  },
  {
    title: "Taro",
    price: "$6.50",
    cardPrice: "$6.76",
    tags: "#70",
  },
  {
    title: "Mocha",
    price: "$6.50",
    cardPrice: "$6.76",
    tags: "#71",
  },
  {
    title: "Milk Tea",
    price: "$6.50",
    cardPrice: "$6.76",
    tags: "#72",
  },
  {
    title: "Avocado",
    price: "$6.50",
    cardPrice: "$6.76",
    tags: "#73",
  },
  {
    title: "Mango",
    price: "$6.50",
    cardPrice: "$6.76",
    tags: "#74",
  },
  {
    title: "Banana",
    price: "$6.50",
    cardPrice: "$6.76",
    tags: "#75",
  },
  {
    title: "Strawberry",
    price: "$6.50",
    cardPrice: "$6.76",
    tags: "#76",
  },
  {
    title: "Green Apple",
    price: "$6.50",
    cardPrice: "$6.76",
    tags: "#77",
  },
  {
    title: "Honeydew",
    price: "$6.50",
    cardPrice: "$6.76",
    tags: "#78",
  },
  {
    title: "Lychee",
    price: "$6.50",
    cardPrice: "$6.76",
    tags: "#79",
  },
  {
    title: "Pineapple",
    price: "$6.50",
    cardPrice: "$6.76",
    tags: "#80",
  },
  {
    title: "Peach",
    price: "$6.50",
    cardPrice: "$6.76",
    tags: "#81",
  },
  {
    title: "Thai Tea",
    price: "$6.50",
    cardPrice: "$6.76",
    tags: "#82",
  },
  {
    title: "Passionfruit",
    price: "$6.50",
    cardPrice: "$6.76",
    tags: "#83",
  },
  {
    title: "Crazy Drink",
    price: "$6.50",
    cardPrice: "$6.76",
    tags: "#84",
  },
];

// Assign the object to a variable before exporting
const menu = {
  pho,
  appetizer,
  vermicelli,
  lomein,
  rice_and_noodle,
  kids,
  beverages,
  boba,
};

export default menu;
